import { render, staticRenderFns } from "./Acropoli.vue?vue&type=template&id=0781ccee&scoped=true&"
import script from "./Acropoli.vue?vue&type=script&lang=js&"
export * from "./Acropoli.vue?vue&type=script&lang=js&"
import style0 from "./Acropoli.vue?vue&type=style&index=0&id=0781ccee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0781ccee",
  null
  
)

export default component.exports